// eslint-disable-next-line import/no-anonymous-default-export
export default {
    awaiting: 1,
    running: 2,
    finished: 3,
    error: 4,
};
